
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import Modal from "react-modal";
import { ShoppingCart } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

Modal.setAppElement("#root");

// ⭐ IMAGE CARD COMPONENT
const ImageCard = ({ combo, addToCart, quantities }) => {
  const [hovered, setHovered] = useState(false);
  const quantity = quantities[combo.dishId] || 0;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 1024px)");

  return (
    <div
      onMouseEnter={() => !isMobile && setHovered(true)}
      onMouseLeave={() => !isMobile && setHovered(false)}
      style={{
        padding: isMobile ? "4px" : isTablet ? "6px" : "8px",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginBottom: isMobile ? "8px" : "0",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: isMobile ? "100%" : isTablet ? "280px" : "300px",
          height: isMobile ? "280px" : isTablet ? "300px" : "320px",
          borderRadius: "16px",
          overflow: "hidden",
          position: "relative",
          background: "#000",
          transform: hovered ? "scale(1.03)" : "scale(1)",
          transition: "0.3s",
          cursor: "pointer",
          boxShadow: isMobile ? "0 4px 8px rgba(0,0,0,0.1)" : "0 6px 12px rgba(0,0,0,0.15)",
        }}
      >
        <img
          src={combo.dishImage}
          alt={combo.dishName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            inset: 0,
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 2,
          }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            padding: isMobile ? "12px" : "16px",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            zIndex: 3,
          }}
        >
          <div>
            <div
              style={{
                background: "red",
                color: "#fff",
                fontSize: isMobile ? "12px" : "14px",
                fontWeight: 700,
                padding: isMobile ? "4px 12px" : "6px 14px",
                borderRadius: "20px",
                width: "fit-content",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              🔥 {combo.discount || 10}% OFF
            </div>
          </div>

          <div>
            <h3 style={{ 
              fontSize: isMobile ? "18px" : "20px", 
              fontWeight: 700, 
              marginBottom: isMobile ? "8px" : "10px",
              lineHeight: "1.2",
            }}>
              {combo.dishName}
            </h3>

            {/* PRICE + ADD TO CART */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: isMobile ? "8px" : "10px",
              }}
            >
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: isMobile ? "8px" : "10px",
                flexWrap: "wrap"
              }}>
                <div
                  style={{
                    background: "green",
                    padding: isMobile ? "8px 10px" : "10px 12px",
                    borderRadius: "8px",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: isMobile ? "14px" : "15px",
                    whiteSpace: "nowrap",
                  }}
                >
                  ₹{combo.price}
                </div>

                <div
                  style={{
                    color: "#ffcccc",
                    fontSize: isMobile ? "12px" : "14px",
                    textDecoration: "line-through",
                    whiteSpace: "nowrap",
                  }}
                >
                  ₹{combo.effectivePrice}
                </div>
              </div>

              {quantity === 0 ? (
                <button
                  onClick={() => addToCart(combo, 1)}
                  style={{
                    padding: isMobile ? "6px 12px" : "8px 14px",
                    backgroundColor: "rgb(177 92 214)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: isMobile ? "12px" : "14px",
                    whiteSpace: "nowrap",
                    minWidth: isMobile ? "80px" : "90px",
                  }}
                >
                  Add to Cart
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ⭐ MOBILE CARDS GRID COMPONENT
const MobileCardsGrid = ({ combos, addToCart, quantities }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "16px",
        padding: "0 12px",
        width: "100%",
        maxWidth: "500px",
        margin: "0 auto",
      }}
    >
      {combos.map((combo) => (
        <ImageCard
          key={combo.dishId}
          combo={combo}
          addToCart={addToCart}
          quantities={quantities}
        />
      ))}
    </div>
  );
};

// ⭐ TABLET CARDS GRID COMPONENT
const TabletCardsGrid = ({ combos, addToCart, quantities }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "16px",
        padding: "0 16px",
        width: "100%",
        maxWidth: "800px",
        margin: "0 auto",
        justifyContent: "center",
      }}
    >
      {combos.map((combo) => (
        <ImageCard
          key={combo.dishId}
          combo={combo}
          addToCart={addToCart}
          quantities={quantities}
        />
      ))}
    </div>
  );
};

// ⭐ MAIN COMPONENT
export default function Combos() {
  const [combos, setCombos] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  
  // Media queries for responsive behavior
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const isDesktop = useMediaQuery("(min-width: 1025px)");

  // Fetch Combos
  useEffect(() => {
    const loadCombos = async () => {
      try {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) return;

        const res = await axios.get(
          ` https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const combosCategory = res.data.find(
          (x) => x.dishName?.toUpperCase() === "COMBOS"
        );

        if (!combosCategory) return;

        const list = res.data.filter(
          (x) => x.parentId === combosCategory.dishId
        );

        setCombos(list);
      } catch (e) {
        console.log("Error:", e);
      }
    };

    loadCombos();
  }, []);

  // Add to cart
  const addToCart = async (item, qty = 1) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) return alert("Please login first.");

    try {
      await axios.post(
        ` https://backend.maamaas.com/food/api/cart/add/${userId}`,
        { dishId: item.dishId, quantity: qty },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setQuantities((prev) => ({
        ...prev,
        [item.dishId]: qty,
      }));

      setCartItems((prev) => [...prev, { ...item, quantity: qty }]);
      setIsModalOpen(true);
    } catch (e) {
      alert("Error adding to cart");
    }
  };

  // Auto close modal after 2 seconds
  useEffect(() => {
    let autoCloseTimer;
    
    if (isModalOpen) {
      autoCloseTimer = setTimeout(() => {
        setIsModalOpen(false);
      }, 2000);
    }

    return () => {
      if (autoCloseTimer) {
        clearTimeout(autoCloseTimer);
      }
    };
  }, [isModalOpen]);

  // View Cart
  const handleViewCartClick = () => navigate("/cartsdata");

  // Slider Settings - Only for desktop
  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { 
        breakpoint: 1025, 
        settings: { 
          slidesToShow: 3,
          dots: true
        } 
      },
      { 
        breakpoint: 900, 
        settings: { 
          slidesToShow: 2,
          dots: true
        } 
      },
      { 
        breakpoint: 769, 
        settings: "unslick" // Disable slider below 769px
      },
    ],
  };

  // Render content based on screen size
  const renderContent = () => {
    if (isMobile) {
      return (
        <MobileCardsGrid 
          combos={combos} 
          addToCart={addToCart} 
          quantities={quantities} 
        />
      );
    } else if (isTablet) {
      return (
        <TabletCardsGrid 
          combos={combos} 
          addToCart={addToCart} 
          quantities={quantities} 
        />
      );
    } else {
      return (
        <Slider {...sliderSettings}>
          {combos.map((combo) => (
            <ImageCard
              key={combo.dishId}
              combo={combo}
              addToCart={addToCart}
              quantities={quantities}
            />
          ))}
        </Slider>
      );
    }
  };

  return (
    <section style={{ 
      maxWidth: "1200px", 
      margin: "0 auto", 
      marginTop: isMobile ? "10px" : "20px",
      padding: isMobile ? "0 8px" : "0 16px",
    
    }}>
      {/* HEADER */}
      <h1
        style={{
          textAlign: "center",
          fontSize: isMobile ? "28px" : isTablet ? "32px" : "34px",
          fontWeight: 800,
          marginBottom: isMobile ? "16px" : "24px",
          padding: isMobile ? "0 8px" : "0",
          lineHeight: "1.2",
        }}
      >
        <span style={{ color: "rgb(42 9 71)" }}>Com</span>
        <span style={{ color: "red" }}>bos</span> Offers
      </h1>

      {/* CONTENT */}
      {renderContent()}

      {/* STICKY BOTTOM MODAL */}
      <Modal
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={false}
        style={{
          overlay: { 
            backgroundColor: "transparent", 
            pointerEvents: "none",
            zIndex: 1000 
          },
          content: {
            pointerEvents: "auto",
            position: "fixed",
            bottom: isMobile ? "20px" : "30px",
            top: "auto",
            left: "50%",
            transform: "translateX(-50%)",
            width: isMobile ? "90%" : isTablet ? "85%" : "80%",
            maxWidth: "500px",
            border: "none",
            borderRadius: "12px",
            padding: "0",
            height: isMobile ? "65px" : "70px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: isMobile ? "12px 16px" : "14px 20px",
            borderRadius: "12px",
            border: "2px solid #ee6521",
            background: "#fff",
            height: "100%",
            width: "100%",
          }}
        >
          <ShoppingCart style={{ 
            fontSize: isMobile ? "24px" : "28px", 
            color: "#ee6521",
            flexShrink: 0,
          }} />

          {/* ITEMS COUNT */}
          <div style={{ 
            fontSize: isMobile ? "16px" : "18px", 
            fontWeight: "bold",
            flexShrink: 0,
            margin: "0 8px",
          }}>
            ({Object.values(quantities).reduce((a, b) => a + b, 0)}) Items
          </div>

          {/* QUANTITY CONTROL FOR LAST ADDED ITEM */}
          {cartItems.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: isMobile ? "6px" : "8px",
                background: "#f8f8f8",
                padding: isMobile ? "4px 6px" : "6px 8px",
                borderRadius: "8px",
                flexShrink: 0,
                margin: "0 8px",
              }}
            >
              {/* MINUS BUTTON */}
              <button
                onClick={() =>
                  addToCart(
                    cartItems[cartItems.length - 1],
                    Math.max(
                      0,
                      (quantities[cartItems[cartItems.length - 1].dishId] || 1) - 1
                    )
                  )
                }
                style={{
                  padding: isMobile ? "2px 6px" : "4px 8px",
                  background: "red",
                  color: "#fff",
                  borderRadius: "6px",
                  border: "none",
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  minWidth: isMobile ? "24px" : "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                –
              </button>

              {/* QUANTITY NUMBER */}
              <span style={{ 
                fontSize: isMobile ? "14px" : "16px", 
                fontWeight: "bold",
                minWidth: isMobile ? "20px" : "24px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                {quantities[cartItems[cartItems.length - 1].dishId] || 1}
              </span>

              {/* PLUS BUTTON */}
              <button
                onClick={() =>
                  addToCart(
                    cartItems[cartItems.length - 1],
                    (quantities[cartItems[cartItems.length - 1].dishId] || 1) + 1
                  )
                }
                style={{
                  padding: isMobile ? "2px 6px" : "4px 8px",
                  background: "green",
                  color: "#fff",
                  borderRadius: "6px",
                  border: "none",
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  minWidth: isMobile ? "24px" : "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                +
              </button>
            </div>
          )}

          {/* VIEW CART BTN */}
          <button
            style={{
              borderRadius: "50px",
              background: "#ee6521",
              color: "#fff",
              padding: isMobile ? "6px 12px" : "8px 16px",
              border: "none",
              cursor: "pointer",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "bold",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
            onClick={handleViewCartClick}
          >
            View Cart
          </button>
        </div>
      </Modal>
    </section>
  );
}